
<!--<app-alerts></app-alerts>-->
<main>
  <section>
    <div #top class="container-fluid ptb-42">
      <div class="row">
        <div class="col-auto">
          <div class="titles-bdr-r">
            <h1 class="color-primary fs-325remTitles">{{supportPageInfo.Titulo_Pagina}}</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="container gx-5 gx-lg-0 pb-120">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-12">
          <form class="contact-form" [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="showForm">
            <fieldset> <!-- Put 'disable' if form is submited -->
              <div class="row">

                <!-- Name input -->
                <div class="form-group col-sm-6 col-12 mb-3">
                  <label aria-label="Nome" class="mb-1">{{'formLabels.nome' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                  <input type="text" class="form-control" placeholder="{{'formPlaceholders.nome' | translate}}" formControlName="firstName" [ngClass]="{ 'is-invalid': submitted && f['firstName'].errors }">
                  <div *ngIf="submitted && f['firstName'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                </div>

                <!-- Second Name input -->
                <div class="form-group col-sm-6 col-12 mb-3">
                  <label aria-label="Apelido" class="mb-1">{{'formLabels.apelido' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                  <input type="text" class="form-control" placeholder="{{'formPlaceholders.apelido' | translate}}" formControlName="lastName" [ngClass]="{ 'is-invalid': submitted && f['lastName'].errors }">
                  <div *ngIf="submitted && f['lastName'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                </div>

                <!-- Email input -->
                <div class="form-group col-12 mb-3">
                  <label aria-label="Email" class="mb-1">{{'formLabels.email' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                  <input type="email" class="form-control" placeholder="{{'formPlaceholders.email' | translate}}" formControlName="email" [ngClass]="{ 'is-invalid': submitted && f['email'].errors }">
                  <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
                    <div *ngIf="f['email'].errors['required']">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                    <div *ngIf="f['email'].errors['email']">{{'formErrorFeedback.emailValido' | translate}}</div>
                  </div>
                </div>

                <!-- Number input -->
                <div class="form-group col-12 mb-3">
                  <label aria-label="Contacto" class="mb-1">{{'formLabels.contacto' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                  <ngx-intl-tel-input
                    [cssClass]="'form-control'"
                    [preferredCountries]="preferredCountries"
                    [enableAutoCountrySelect]="true"
                    [enablePlaceholder]="true"
                    [customPlaceholder]="'formPlaceholders.contacto' | translate"
                    [searchCountryFlag]="true"
                    [searchCountryField]="[SearchCountryField.Iso2,SearchCountryField.Name]"
                    [selectFirstCountry]="false"
                    [selectedCountryISO]="CountryISO.Portugal"
                    [maxLength]="15"
                    [phoneValidation]="true"
                    formControlName="phone"
                    [numberFormat]="PhoneNumberFormat.National"
                    [ngClass]="{ 'is-invalid': submitted && f['phone'].errors }">
                  </ngx-intl-tel-input>
                  <div *ngIf="submitted && f['phone'].errors" class="invalid-feedback">{{'formErrorFeedback.telefoneValido' | translate}}</div>
                </div>

                <!-- Subject input -->
                <div class="form-group col-12 mb-3">
                  <label aria-label="Assunto" class="mb-1">{{'formLabels.assunto' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                  <select aria-label="Selecionar Assunto" class="form-select" formControlName="subject" [ngClass]="{ 'is-invalid': submitted && f['subject'].errors }">
                    <option value="" disabled selected>{{'formPlaceholders.selecionar' | translate}}</option>
                    <option value="INFORMATION_REQUEST">{{ 'formSubject.pedidoInformação' | translate }}</option>
                    <option value="DOCUMENT_REQUEST">{{ 'formSubject.pedidoDocumento' | translate }}</option>
                    <option value="COMPLAINT">{{ 'formSubject.reclamações' | translate }}</option>
                    <option value="LOST_AND_FOUND">{{ 'formSubject.perdidosAchados' | translate }}</option>
                    <option value="SUGGESTION">{{ 'formSubject.sugestao' | translate }}</option>
                    <option value="COMPLIMENT">{{ 'formSubject.elogio' | translate }}</option>
                  </select>
                  <div *ngIf="submitted && f['subject'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                </div>

                <ng-container *ngIf="complaint">

                  <!-- Sub-subject input -->
                  <div class="form-group col-12 mb-3">
                    <label aria-label="Motivo" class="mb-1">{{'formLabels.motivo' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                    <select aria-label="Selecionar Motivo" class="form-select" formControlName="subsubject" [ngClass]="{ 'is-invalid': submitted && f['subsubject'].errors }">
                      <option value="" disabled selected>{{'formPlaceholders.selecionar' | translate}}</option>
                      <option value="Atendimento e relacionamento com os passageiros##true">{{ 'formComplaintSubject.atendimento' | translate }}</option>
                      <option value="Atraso nas circulações##true">{{ 'formComplaintSubject.atraso' | translate }}</option>
                      <option value="Circulações não realizadas##true">{{ 'formComplaintSubject.naoRealizadas' | translate }}</option>
                      <option value="Conforto e limpeza das paragens##false">{{ 'formComplaintSubject.confLimpParagens' | translate }}</option>
                      <option value="Conforto e limpeza dos veículos##true">{{ 'formComplaintSubject.confLimpVeiculos' | translate }}</option>
                      <option value="Incapacidade de transportar todos os passageiros##true">{{ 'formComplaintSubject.incapacidadeTransporte' | translate }}</option>
                      <option value="Informação disponibilizada aos passageiros##true">{{ 'formComplaintSubject.informação' | translate }}</option>
                      <option value="Horários e frequências das linhas##true">{{ 'formComplaintSubject.horarios' | translate }}</option>
                      <option value="Percursos e paragens das linhas##true">{{ 'formComplaintSubject.percursos' | translate }}</option>
                      <option value="Títulos e tarifas##true">{{ 'formComplaintSubject.titulos' | translate }}</option>
                      <option value="Outros assuntos##true">{{ 'formComplaintSubject.outros' | translate }}</option>
                    </select>
                    <div *ngIf="submitted && f['subsubject'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                  </div>

                </ng-container>

                <ng-container *ngIf="!suggestion">

                  <!-- Municipaly input -->
                  <div class="form-group col-12 mb-3">
                    <label aria-label="Município" class="mb-1">{{'formLabels.municipio' | translate}}<span *ngIf="municipalityRequired" class="text-danger ms-1 fw-800">*</span></label>
                    <select aria-label="Selecionar Município" class="form-select" formControlName="municipality" [ngClass]="{ 'is-invalid': submitted && f['municipality'].errors }">
                      <option value="" selected>{{'formPlaceholders.selecionar' | translate}}</option>
                      <option *ngFor="let municipality of municipalities" value="{{municipality.code}}">{{municipality.name}}</option>
                    </select>
                    <div *ngIf="submitted && f['municipality'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                  </div>

                  <!-- Line input -->
                  <div class="form-group col-12 mb-3">
                    <label aria-label="Linha" class="mb-1">{{'formLabels.linha' | translate}}<span *ngIf="lineRequired" class="text-danger ms-1 fw-800">*</span></label>
                    <select aria-label="Selecionar Linha" class="form-select" formControlName="line" [ngClass]="{ 'is-invalid': submitted && f['line'].errors }">
                      <option value="" selected>{{'formPlaceholders.selecionar' | translate}}</option>
                      <option *ngFor="let line of lines" value="{{line.number}}">{{line.number}} - {{line.name}}</option>
                    </select>
                    <div *ngIf="submitted && f['line'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                  </div>

                  <!-- Line input -->
                  <div *ngIf="lineOperator != ''" class="col-12 mb-3 d-flex align-items-center">
                    <label aria-label="Operador" class="mb-1">{{'formLabels.operador' | translate}}:&nbsp;</label>
                    <ng-container *ngFor="let logo of lineOperatorLogos; let i = index" >
                      <img
                        [src]="'assets/img/logos/operators/' + logo + '.png'"
                        [alt]="logo"
                        class="p-3 logo-footer"/>
                      <span *ngIf="i < lineOperatorLogos.length -1">/</span>
                    </ng-container>

                  </div>

                  <!-- Unknown Operator -->
                  <div *ngIf="unknownOperator" class="alert alert-warning">
                    <p class="m-0">{{ 'formFeedback.unknownOperator' | translate }}</p>
                  </div>

                  <!-- Stop input -->
                  <div class="form-group col-lg-6 col-12 mb-3">
                    <label aria-label="Paragem" class="mb-1">{{'formLabels.paragem' | translate}}</label>
                    <select aria-label="Selecionar Paragem" class="form-select" formControlName="stop" [ngClass]="{ 'is-invalid': submitted && f['stop'].errors }">
                      <option value="" selected>{{'formPlaceholders.selecionar' | translate}}</option>
                      <option *ngFor="let stop of stops" value="{{stop.code + ' - ' + stop.name}}">{{stop.code}} - {{stop.name}}</option>
                    </select>
                    <div *ngIf="submitted && f['stop'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                  </div>

                  <!-- Local input -->
                  <div class="form-group col-lg-6 col-12 mb-3">
                    <label aria-label="Local" class="mb-1">{{'formLabels.local' | translate}}</label>
                    <input type="text" class="form-control" placeholder="{{'formPlaceholders.local' | translate}}" formControlName="place" [ngClass]="{ 'is-invalid': submitted && f['place'].errors }">
                    <div *ngIf="submitted && f['place'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                  </div>

                  <!-- Date input -->
                  <div class="form-group col-lg-4 col-12 mb-3">
                    <label aria-label="Data" class="mb-1">{{'formLabels.data' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                    <input type="text" class="form-control" bsDatepicker [bsValue]="bsValue" [bsConfig]="bsConfig" formControlName="date" [ngClass]="{ 'is-invalid': submitted && f['date'].errors }" >
                    <div *ngIf="submitted && f['date'].errors" class="invalid-feedback">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                  </div>

                  <!-- Hour input -->
                  <div class="form-group col-lg-3 col-12 mb-3 timepickerForm">
                    <div class="d-inline-flex">
                      <label aria-label="Hora" class="mb-1 align-self-center me-3">{{'formLabels.hora' | translate}}</label>
                      <div class="d-inline-flex">
                        <timepicker formControlName="time" [showMeridian]="false" [ngClass]="{ 'is-invalid': submitted && f['time'].errors }"></timepicker>
                        <div *ngIf="submitted && f['time'].errors" class="invalid-feedback align-self-center ms-3">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                      </div>
                    </div>
                  </div>

                </ng-container>

                <!-- Message Text -->
                <div class="form-group col-12 mb-3">
                  <label aria-label="Mensagem" class="mb-1">{{'formLabels.mensagem' | translate}}<span class="text-danger ms-1 fw-800">*</span></label>
                  <textarea class="form-control" placeholder="{{'formPlaceholders.mensagem' | translate}}" formControlName="message" [ngClass]="{ 'is-invalid': submitted && f['message'].errors }" style="height: 120px"></textarea>
                  <div *ngIf="submitted && f['message'].errors" class="invalid-feedback">
                    <div *ngIf="f['message'].errors['required']">{{'formErrorFeedback.preenchimentoObrigatorio' | translate}}</div>
                    <div *ngIf="f['message'].errors['minlength']">{{'formErrorFeedback.mensagemMinLength' | translate}}</div>
                    <div *ngIf="f['message'].errors['maxlength']">{{'formErrorFeedback.mensagemMaxLength' | translate}}</div>
                  </div>
                </div>

                <!-- File Upload Text -->
                <div class="form-group col-12 mb-3">
                  <label aria-label="Anexos" class="mb-1" for="files">{{'formLabels.anexos' | translate}}</label>
                  <input class="form-control" id="files" type="file" title="Anexar Ficheiros" formControlName="files" multiple (change)="onFileChange($event)"
                         accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"/>
                </div>
                <div *ngIf="fileError" class="form-group col-12 mb-3"><span [innerHTML]="fileError"></span></div>
                <div *ngFor="let file of selectedFiles" class="trash-form col-auto mb-3">{{ file.name }}<i class="uil uil-trash-alt ms-2" (click)="removeFile(file)" title="Eliminar Ficheiro"></i></div>
                <div *ngIf="selectedFiles.length > 0" class="col-12 text-center mb-3"><b>{{'formPlaceholders.totalFicheiros' | translate}} {{ selectedFiles.length }} {{'formPlaceholders.ficheiros' | translate}}</b></div>
                <div *ngIf="fileErrorMax" class="invalid-feedback d-block mb-3"><span [innerHTML]="fileErrorMax"></span></div>

                <!-- CheckBox -->
                <div class="form-group col-12 my-3">
                  <div class="form-check">
                    <input type="checkbox" id="acceptTerms" formControlName="acceptTerms" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f['acceptTerms'].errors }"/>
                    <label aria-label="Checkbox Termos e Condições" for="acceptTerms" class="form-check-label fs-12px">{{'formPlaceholders.termosText1' | translate}} <a [routerLink]="'/politica-privacidade'" target="_blank">{{'navLinks.politicaPrivacidade' | translate}}</a>{{'formPlaceholders.termosText2' | translate}}</label>
                    <div *ngIf="submitted && f['acceptTerms'].errors" class="invalid-feedback">{{'formErrorFeedback.termosObrigatorio' | translate}}</div>
                  </div>
                </div>

                <!-- Submit button -->
                <div class="justify-content-end col-12 d-flex form-group my-3">
                  <button *ngIf="!inProgress" type="button" (click)="onReset()" class="btn btn-outline-secondary me-4" title="Limpar Formulário"><p class="m-0 fw-600">{{'buttons.limpar' | translate}}<i class="uil uil-backspace fs-20px ms-2"></i></p></button>
                  <button *ngIf="!unknownOperator && !inProgress && !success" type="submit" class="btn btn-primary col-lg-2 col-6" title="Enviar Formulário"><p class="m-0 fw-600">{{'buttons.enviar' | translate}}<i class="uil uil-arrow-up-right fs-20px ms-2 color-white"></i></p></button>
                </div>

              </div>
            </fieldset>
          </form>

          <!-- Loading Message -->
          <div *ngIf="inProgress" class="alert alert-warning">
            <p class="m-0">{{ 'formFeedback.submitting' | translate }}</p>
            <p class="m-0">{{ 'formFeedback.pleaseWait' | translate }}</p>
          </div>
          <!-- Success Info -->
          <div *ngIf="success" class="alert alert-success">
            <p class="m-0">{{ 'formFeedback.successInfoLine1' | translate }}</p>
            <p class="m-0">{{ 'formFeedback.successInfoLine2' | translate }}</p>
            <p class="m-0 fw-800">{{ 'formFeedback.successInfoLine3' | translate }}</p>
          </div>
          <!-- Success Complaint Info -->
          <div *ngIf="successComplaint && !errorOnFiles" class="alert alert-success">
            <p class="m-0">{{ 'formFeedback.successComplaintLine1' | translate }} <b>{{addedComplaintIdentifier}}</b>!</p>
            <p class="m-0">{{ 'formFeedback.successComplaintLine2' | translate }}</p>
            <p class="m-0 fw-800">{{ 'formFeedback.successComplaintLine3' | translate }}</p>
          </div>
          <div *ngIf="successComplaint  && errorOnFiles" class="alert alert-warning">
            <p class="m-0">{{ 'formFeedback.errorComplaintFileLine1_1' | translate }} <b>{{addedComplaintIdentifier}}</b> {{ 'formFeedback.errorComplaintFileLine1_2' | translate }}</p>
            <p class="m-0">{{ 'formFeedback.errorComplaintFileLine2' | translate }}</p>
            <p class="m-0 fw-800">{{ 'formFeedback.errorComplaintFileLine3' | translate }}</p>
          </div>

        </div>
      </div>
    </div>
  </section>
</main>

